export interface Loader {
  id: string;
  status: boolean;
}

export const storeInformationId =
  { permission: 'permission', userInformation: 'userInformation', tokenInformation: 'tokenInformation', loggedInUserInformation: 'loggedInUserInformation' };

export const localStorageInformationId =
  { tokenInformation: 'tokenInformation', loggedInUserInformation: 'loggedInUserInformation', userTokenInfo:'UserToken' };
//domain: `${window.location.protocol}//${window.location.host}/api/v1.0`
export const systemConstants = {
  // orgId: 1011,
    domain: `https://nvapigateway.onlinevidyalaya.net/gateway/Incometax`,
  //  domain: `https://localhost:2710/gateway/Incometax`,
  webSiteUrl: `${window.location.protocol}//${window.location.host}`,
  // bodyToken: 'Occucare@123'
}

const s4 = Math.floor((1 + Math.random()) * 0x10000)
  .toString(16)
  .substring(1);

export let pageName = '';
export class PageName {
  SetPageName(str) {
    pageName = str;
    document.getElementsByTagName('title')[0].innerHTML = str;
  }
}

export class DateExtension {
  static ToString(dt: Date, format: string) {

    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dd = NumberExtension.PadNum(dt.getDate(), '0', 2);
    const MM = NumberExtension.PadNum(dt.getMonth() + 1, '0', 2);
    const MMM = mnthary[dt.getMonth()];
    const yyyy = dt.getFullYear().toString();
    const HH = NumberExtension.PadNum(dt.getHours(), '0', 2);
    const hh = StringExtension.ToInt(HH) >= 12 ? (StringExtension.ToInt(HH) - 12).toString() : HH.toString();
    const min = NumberExtension.PadNum(dt.getMinutes(), '0', 2);
    return format.replace('dd', dd).replace('MMM', MMM).replace('MM', MM).replace('yyyy', yyyy).replace('HH', HH)
      .replace('hh', StringExtension.ToInt(hh) > 10 ? hh.toString() : (hh.length === 2 ? hh : '0' + hh).toString()).replace('mm', min);
  }

  static ToDate(dt: string, fromFormat: string, sep: string) {
    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // fromFormat
    const ffdt = fromFormat.split(' ')[0];
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[1] : '';
    const fftt = fromFormat.split(' ').length > 2 ? fromFormat.split(' ')[2] : '';

    const vfdt = dt.split(' ')[0];
    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[1] : '';
    const vftt = dt.split(' ').length > 2 ? dt.split(' ')[2] : '';

    const idd = ffdt.split(sep).findIndex(e => e === 'dd');
    const iMM = ffdt.split(sep).findIndex(e => e === 'MM'); // starts from 1
    // const imm = ffdt.split(sep).findIndex(e => e === 'mm'); // starts from 0
    const iMMM = ffdt.split(sep).findIndex(e => e === 'MMM'); // short form
    const iyyyy = ffdt.split(sep).findIndex(e => e === 'yyyy');
    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;
    const itt = fftt;
    const dd = StringExtension.ToInt(vfdt.split(sep)[idd]);
    const mm = iMM >= 0 ? (StringExtension.ToInt(vfdt.split(sep)[iMM]) - 1) : mnthary.indexOf(vfdt.split(sep)[iMMM]);

    const yyyy = StringExtension.ToInt(vfdt.split(sep)[iyyyy]);
    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 : StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    return new Date(yyyy, mm, dd, hh, min);

  }

  static Map(dt: string, fromFormat: string, toFormat: string, sep: string, isString: boolean = true) {
    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (fromFormat.indexOf('T') > 0) {
      dt = dt.replace('T', ' ');
      fromFormat = fromFormat.replace('T', ' ');
    }
    // fromFormat
    const ffdt = fromFormat.split(' ')[0];
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[1] : '';
    const fftt = fromFormat.split(' ').length > 2 ? fromFormat.split(' ')[2] : '';

    const vfdt = dt.split(' ')[0];
    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[1] : '';
    const vftt = dt.split(' ').length > 2 ? dt.split(' ')[2] : '';

    const idd = ffdt.split(sep).findIndex(e => e === 'dd');
    const iMM = ffdt.split(sep).findIndex(e => e === 'MM'); // starts from 1
    // const imm = ffdt.split(sep).findIndex(e => e === 'mm'); // starts from 0
    const iMMM = ffdt.split(sep).findIndex(e => e === 'MMM'); // short form
    const iyyyy = ffdt.split(sep).findIndex(e => e === 'yyyy');
    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;
    const itt = fftt;
    const dd = StringExtension.ToInt(vfdt.split(sep)[idd]);
    const mm = iMM >= 0 ? (StringExtension.ToInt(vfdt.split(sep)[iMM]) - 1) : mnthary.indexOf(vfdt.split(sep)[iMMM]);

    const yyyy = StringExtension.ToInt(vfdt.split(sep)[iyyyy]);
    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 : StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    hh = isNaN(hh) ? 0 : hh;
    min = isNaN(min) ? 0 : min;

    const FromDate = new Date(yyyy, mm, dd, hh, min);
    const hour = StringExtension.ToInt(NumberExtension.PadNum(FromDate.getHours(), '0', 2));
    return isString ? toFormat.replace('dd', (NumberExtension.PadNum(FromDate.getDate(), '0', 2)))
      .replace('MMM', mnthary[FromDate.getMonth()])
      .replace('MM', (NumberExtension.PadNum((FromDate.getMonth() + 1), '0', 2)))
      .replace('yyyy', FromDate.getFullYear().toString())
      .replace('hh', (hour > 11 ? (NumberExtension.PadNum((hour == 12 ? hour : (hour - 12)), '0', 2)) : (NumberExtension.PadNum((hour == 0 ? 12 : hour), '0', 2))))
      .replace('HH', (NumberExtension.PadNum(hour, '0', 2)))
      .replace('mm', NumberExtension.PadNum(FromDate.getMinutes(), '0', 2))
      .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'))
      : toFormat.replace('dd', (NumberExtension.PadNum(FromDate.getDate(), '0', 2)))
        .replace('MMM', mnthary[FromDate.getMonth()])
        .replace('MM', (FromDate.getMonth() + 1).toString())
        .replace('yyyy', FromDate.getFullYear().toString())
        .replace('hh', (hour > 11 ? (hour == 12 ? hour : (hour - 12)).toString() : (hour == 0 ? 12 : hour).toString()))
        .replace('HH', hour.toString())
        .replace('mm', FromDate.getMinutes().toString())
        .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'));


  }

  static APItoUI(dt: string) {
    return DateExtension.Map(dt, 'MM-dd-yyyy HH:mm', 'dd-MMM-yyyy hh:mm tt', '-');
  }

  static UItoAPI(dt: string) {
    return DateExtension.Map(dt, 'dd-MMM-yyyy hh:mm tt', 'MM-dd-yyyy HH:mm', '-') + ':00';
  }

  static MapTime(dt: string, fromFormat: string, toFormat: string, sep: string) {
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[0] : '';
    const fftt = fromFormat.split(' ').length >= 2 ? fromFormat.split(' ')[1] : '';

    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[0] : '';
    const vftt = dt.split(' ').length >= 2 ? dt.split(' ')[1] : '';

    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;

    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 :
          StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    const FromDate = new Date(hh, min);
    const hour = hh;
    return toFormat.replace('hh', (hour > 11 ? (NumberExtension.PadNum((hour - 12), '0', 2)) : (NumberExtension.PadNum(hour, '0', 2))))
      .replace('HH', (NumberExtension.PadNum(hour, '0', 2)))
      .replace('mm', NumberExtension.PadNum(min, '0', 2))
      .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'));
  }
  static UItoAPITime(dt: string) {
    return DateExtension.MapTime(dt, 'hh:mm tt', 'HH:mm', '-') + ':00.0000000';
  }

}

export class StringExtension {
  static IsNullOrWhiteSpace(s) {
    return ((s !== undefined && s != null && (typeof (s) !== 'string' ? s.toString() : s).trim() !== '') ? false : true);
  }
  static Guid() {
    return s4 + s4 + '-' + s4 + '-' + s4 + '-' + s4 + '-' + s4 + s4 + s4;
  }

  static ToInt(s) {
    return parseInt(s, 10);
  }
  static ToFloat(s) {
    return parseFloat(s);
  }
  static ToFixedDecimal(s, digit) {
    // let a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
    return parseFloat(s.toFixed(digit));
  }
  // static ToFixed(a, d) {
  //   // var a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
  //   // return Math.floor(s) + parseFloat(a.toFixed(digit));

  //   let t = a.toString().split('.')[1];
  //   if (t === undefined) {
  //     t = '00';
  //   }
  //   while (t.length > d) {
  //     t = parseInt(t[t.length - 1], 10) < 5 ? t.substring(0, t.length - 1) : (parseInt(t.substring(0, t.length - 1), 10) + 1).toString();
  //   }
  //   return parseFloat(a.toString().split('.')[0] + '.' + t);
  // }
  static ToFixed(a, d) {
    // var a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
    // return Math.floor(s) + parseFloat(a.toFixed(digit));

    //let t = a.toString().split('.')[1]; /// 17.9456
    //if (t === undefined) {
    //  t = '00';
    //}
    ////debugger;
    ////t = t.substring(0, d + 1);
    //while (t.length > d) {

    //  t = parseInt(t[t.length - 1], 10) < 5 ? t.substring(0, t.length - 1) : (parseInt(t.substring(0, t.length - 1), 10) + 1).toString();
    //}
    //return parseFloat(a.toString().split('.')[0] + '.' + t);
    return Math.round((a + 0.00001) * 100) / 100;
  }
}

export class NumberExtension {
  static PadNum(val, padd, count): string {
    let value = '';
    value = typeof (val) === 'number' ? val.toString() : val;
    for (let index = 0; index < (count - value.length); index++) {
      value = padd + value;
    }
    return value;
  }
}
